var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navi"},[_c('div',{staticClass:"icon"}),_c('el-breadcrumb',{staticStyle:{"height":"60px","line-height":"60px"},attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }